<template>
  <div>
    <h2 class="text-center">Xin chào Chuyên gia!</h2>
    <v-container class="pa-4" fluid="fluid" grid-list-md="grid-list-md">
      <v-row justify="center">
        <v-col cols="12" md="3">
          <v-card flat class="text-center blue lighten-1 elevation-3" shaped>
            <v-card-text>
              <div class="display-1 mb-2">{{ total }}</div> Tổng câu hỏi
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="3">
          <v-card flat class="text-center green lighten-1 elevation-3" shaped>
            <v-card-text>
              <div class="display-1 mb-2">{{ rep }}</div> Đã trả lời
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="3">
          <v-card flat class="text-center yellow lighten-1 elevation-3" shaped>
            <v-card-text>
              <div class="display-1 mb-2">{{ notRep }}</div> Chưa trả lời
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="3">
          <v-card flat class="text-center pink lighten-1 elevation-3" shaped>
            <v-card-text>
              <div class="display-1 mb-2">{{ late }}</div> Trễ hạn
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import SystemSevice from '@/services/System';
  export default {
    data () {
      return {
        total: 0,
        notRep: 0,
        rep: 0,
        late: 0
      }
    },
    computed: {
      ...mapState([
        'authMod'
      ])
    },
    mounted() {
      this.countQasAmountByStatus(-1);
      this.countQasAmountByStatus(0);
      this.countQasAmountByStatus(1);
      this.countQasAmountByStatus(2);
    },
    methods: {
      countQasAmountByStatus (status) {
        const app = this;
        app.loading = true;
        let expertId = app.authMod.user.user.info.coso_id;
        axios.get(`api/v1/supports-counter-bystatus/${expertId}/${status}`)
          .then(response => {
            if(status == -1){
              app.total = response.data;
            } else if(status == 0){
              app.notRep = response.data;
            } else if(status == 1){
              app.rep = response.data;
            } else {
              app.late = response.data; 
            }
            app.loading = false;
          })
          .catch(function (error) {
            app.openSnackbar({ type: 'error' });
            SystemSevice.logging('expert.Index', error);
          });
      }
    }
  }
</script>